import { GLOBAL } from '@lumapps/translations';

import { PostSortChoices } from './types';

export const BLOCK_POST_CLASSNAME = 'block-post';

export const WIDGET_COMMUNITY_POST_LIST_TYPE = 'community-post-list';

export const POST_LIST_FILTER_ID = 'post-list-filter';

export const PIN_POST_MAX_COUNT = 50;

/** Default number of visible lines before "Show more" — mirrors the backend `visible_lines` default. */
export const DEFAULT_VISIBLE_LINES = 10;

export const sortChoices: PostSortChoices = {
    desc: { id: '-publicationDate', label: GLOBAL.LATEST },
    asc: { id: 'publicationDate', label: GLOBAL.OLDEST },
};

export const sortChoicesList = Object.values(sortChoices);
